<p>
  product-search works!
</p>
